import {
    CLIENT_LOADED,
    CLIENT_FORM_TOGGLE,
    CONTRACT_UPDATED,
    CONTRACT_SIGNED,
    CONTRACT_CLOSED
} from "../constants/actionTypes";

export default (state = {}, action) => {
    switch (action.type) {
    case CLIENT_LOADED:
        return {
            ...state,
            ...action.payload,
        };
    case CONTRACT_UPDATED:
        const { contract } = action.payload;
        const { car } = contract;
        return {
            ...state,
            client: Object.assign({}, state.client, { cars: state.client.cars.map(c => c._id == car ? Object.assign(c, { contract }) : c )}),
        };
    case CONTRACT_SIGNED:
        return {
            ...state,
            client: Object.assign(state.client, { cars: state.client.cars.map(c => c._id == action.payload.contract.car ? Object.assign(c, { contract: action.payload.contract }, { loan: Object.assign(c.loan, {status: "ACTIVE"})}) : c )}),
        };
    case CONTRACT_CLOSED:
        return {
            ...state,
            client: Object.assign({}, state.client, { cars: state.client.cars.map(c => c._id == action.payload.contract.car ? Object.assign(c, { contract: action.payload.contract }, { loan: Object.assign({}, c.loan, {status: "CLOSED"})}) : c )}),
        };
    case CLIENT_FORM_TOGGLE:
        return {
            ...state,
            detailed: action.toggle,
        };
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/client.js